import { Institution, InstitutionBranch, InstitutionExtended } from '../api/app-types/institution.app';

export const mockSchools: InstitutionBranch[] = [
	{
		id: 1,
		name: 'Test School 1',
		schoolNumber: 'SCH001',
		careerOrientationStartDate: new Date('2024-01-01'),
		cityDistrict: {
			id: 1,
			initial: 'KOE',
			specialistIntegrationService: 'Test Service',
			remark: 'Test District',
			display: 'Köln',
		},
		address: {
			id: 1,
			streetAndHouseNumber: 'Schulstraße 1',
			postalCodeAndCity: '50667 Köln',
			soundexStreet: 'S425',
			anonym: '',
			identifier: 'addr-1',
		},
		workplaceJobs: [],
		isMainInstitution: false,
	},
	{
		id: 2,
		name: 'Test School 2',
		schoolNumber: 'SCH002',
		careerOrientationStartDate: new Date('2024-02-01'),
		cityDistrict: {
			id: 2,
			initial: 'DUS',
			specialistIntegrationService: 'Another Service',
			remark: 'Another District',
			display: 'Düsseldorf',
		},
		address: {
			id: 2,
			streetAndHouseNumber: 'Lernweg 10',
			postalCodeAndCity: '40210 Düsseldorf',
			soundexStreet: 'L652',
			anonym: '',
			identifier: 'addr-2',
		},
		workplaceJobs: [],
		isMainInstitution: false,
	},
];

export const mockInstitution: Institution = {
	id: 1234,
	name: 'PlanB. GmbH',
	workplaces: [
		{
			id: 4321,
			name: 'PlanB. Workplace Hüttlingen',
			cityDistrict: {
				initial: 'AAAA',
				specialistIntegrationService: 'BBBB',
				remark: 'CCCCC',
				display: 'DDDD',
			},
			address: {
				streetAndHouseNumber: 'Kocherstraße 15',
				postalCodeAndCity: '12311 Hüttlingen',
				anonym: '',
				id: 15,
				identifier: '',
				soundexStreet: '',
			},
			workplacesJobs: undefined,
			contactPoints: [],
			institutionPersons: [],
			industryName: '',
			isMainInstitution: false,
		},
	],
	address: {
		postalCodeAndCity: '74360 Hüttlingen',
		streetAndHouseNumber: 'Kocherstraße 15',
		anonym: '',
		id: 1,
		identifier: '',
		soundexStreet: '',
	},
	employmentRequired: false,
	url: 'https://planb.net',
};

export const mockInstitutionExtended: InstitutionExtended = {
	...mockInstitution,
	institutionBranches: mockSchools,
	contactPoints: [
		{
			id: 1,
			personId: 1,
			personTypeId: 1,
			preferredWayOfContact: true,
			categoryContactPointId: 1,
			contactValue: '+49 123 456789',
			remark: 'Mobilfunk. Hier steht eine Bemerkung zum Kommunikationsweg.',
		},
		{
			id: 2,
			personId: 2,
			personTypeId: 2,
			preferredWayOfContact: false,
			contactValue: 'contact@plan-b-gmbh.com',
			categoryContactPointId: 2,
			remark: 'E-Mail ist der heimlich, bessere Kommunikationsweg wenn wir ehrlich sind.',
		},
	],
};
